import { useEffect, useState } from 'react';
import { Category } from 'shared/types/product';
import Drawer from 'components/commercetools-ui/atoms/drawer';
import { ImageProps } from 'components/commercetools-ui/atoms/image';
import { CloseIcon } from 'components/icons';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { mediumDesktop } from 'helpers/utils/screensizes';
import { Reference } from 'types/reference';
import GroupedAccordion from './GroupedAccordian';
import HeaderLogo from './Headerlogo';
import { useProductList } from '../../context';
import { SortConfiguration } from '../../types';
import { GroupedAttribute } from '../list';
export interface DesktopFacetsProps {
  sortConfiguration?: SortConfiguration[];
  className?: string;
  openFacets?: boolean;
  setOpenFacets?: any;
  primaryLogoLight?: ImageProps;
  primaryLogoDark?: ImageProps;
  primaryLogoLink?: Reference;
  primaryLogoLinkMobile?: Reference;
  primaryLogoMobileDark?: ImageProps;
  primaryLogoMobileLight?: ImageProps;
  groupedAttributes?: GroupedAttribute[];
  categories?: Category[];
  tagsToShow?: string;
  facetLoadMoreText?: string;
  facetSeeLessText?: string;
}

const CustomFacets: React.FC<DesktopFacetsProps> = ({
  groupedAttributes,

  openFacets,
  setOpenFacets,
  primaryLogoLight,
  primaryLogoDark,
  primaryLogoLink,
  primaryLogoLinkMobile,
  primaryLogoMobileDark,
  primaryLogoMobileLight,
  categories,
  tagsToShow,
  facetLoadMoreText,
  facetSeeLessText,
  sortConfiguration,
}) => {
  const { refine, activeRefinements, removeAllRefinements } = useProductList();
  const [activeRefineList, setActiveRefineList] = useState<any>([]);

  const [isDesktopSize] = useMediaQuery(mediumDesktop);

  useEffect(() => {
    if (activeRefinements) {
      const temp: any[] = [];
      activeRefinements.forEach((refin) => {
        temp.push(refin.label);
      });
      setActiveRefineList(temp);
    }
  }, [activeRefinements]);

  return (
    <div>
      {isDesktopSize && openFacets ? (
        <GroupedAccordion
          categories={categories}
          groupedAttributes={groupedAttributes}
          activeRefineList={activeRefineList}
          refine={refine}
          tagsToShow={tagsToShow}
          loadMoreText={facetLoadMoreText}
          seeLessText={facetSeeLessText}
        />
      ) : (
        <Drawer
          isOpen={openFacets || false}
          direction="left"
          className="w-3/4 overflow-y-auto bg-white dark:shadow-[8px_0px_20px_4px_#FFFFFF1A] dark:bg-gmsb-gray sm:w-2/4 lg:w-[calc(30%-50px)]"
          onClose={() => {
            setOpenFacets(false);
          }}
          role="dialog"
          blockScrolling={false}
          aria-modal="true"
          aria-label="Mobile menu drawer"
          data-ffid="btn-drawer"
        >
          <div className="mt-8 px-24">
            <div className="mb-26 flex w-full justify-end">
              <button
                onClick={() => {
                  setOpenFacets(false);
                }}
                data-ffid={`btn-close-facets-mob`}
                className="flex size-36 items-center justify-center rounded-[34px] bg-[#F5F5F5] dark:bg-[#5C5C5C]"
                type="button"
              >
                <CloseIcon className="size-18" />
              </button>
            </div>
            <div className="flex justify-center">
              <HeaderLogo
                isDesktopSize={isDesktopSize}
                imageClassName="flex w-full justify-center text-center text-16 font-bold md:text-28"
                ariaLabelLogo="logo"
                primaryLogoLight={primaryLogoLight}
                primaryLogoDark={primaryLogoDark}
                primaryLogoLink={primaryLogoLink}
                primaryLogoLinkMobile={primaryLogoLinkMobile}
                primaryLogoMobileDark={primaryLogoMobileDark}
                primaryLogoMobileLight={primaryLogoMobileLight}
              />
            </div>
            <span className="mb-4 text-18 font-bold text-green-800" data-ffid={`lbl-filter-custom-mob`}>
              {sortConfiguration?.[0]?.filterFacetTextForMobile}
            </span>
            <GroupedAccordion
              categories={categories}
              groupedAttributes={groupedAttributes}
              activeRefineList={activeRefineList}
              refine={refine}
              tagsToShow={tagsToShow}
              loadMoreText={facetLoadMoreText}
              seeLessText={facetSeeLessText}
            />
            <div className="mt-24 flex w-full justify-end">
              <button
                className="rounded-full border border-green-800 px-30 py-7 text-green-800"
                onClick={removeAllRefinements}
                data-ffid={`btn-clear-facets-mob`}
              >
                {sortConfiguration?.[0]?.clearBtnTextForMobile}
              </button>
            </div>
          </div>
        </Drawer>
      )}
    </div>
  );
};
export default CustomFacets;
